import api from 'api';

export interface OnboardingOatFiSchema {
  businessesId: number;
  createdOn: string;
  createdBy: string;
  modifiedOn: string;
  modifiedBy: string;
}

export interface OnboardingOatFiResponseSchema {
  externalId: string;
}

interface OatFiTokenResponse {
  access_Token: string;
  expires_In: number;
  mode: string;
  refresh_Token: string;
  scopes: string[];
  token_Type: string;
}

export const onboardingOatFi = async (
  payload: Partial<OnboardingOatFiSchema>,
) => {
  const result: OnboardingOatFiResponseSchema = await api.post(
    'Integrations/OatFi/Onboarding',
    payload,
    { skipServerErrorModal: true },
  );

  return result?.externalId || null;
};

export const getOatFiToken = async (businessesId: number) => {
  try {
    const result: OatFiTokenResponse = await api.post(
      'Integrations/OatFi/Onboarding/GetOatFiToken',
      { businessesId },
    );

    return result?.access_Token || '';
  } catch (error) {
    return '';
  }
};
